import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Button } from '@components';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';
import {
    boPhanGetAllAction,
    boPhanUpdateAction
} from '@app/store/reducers/boPhan';
import { URI_INTERNAL } from '@app/utils/pathLocations';
import { toast } from 'react-toastify';
import { messageToast } from '@app/utils/define';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const BoPhanEdit = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const query = useQuery();
    const idParam = query.get('id');
    const id = idParam ? parseInt(idParam, 10) : NaN;

    const { list } = useSelector((state) => state.boPhan);
    const [maBoPhan, setMaBoPhan] = useState('');
    const [tenBoPhan, setTenBoPhan] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (!list || list.length === 0) {
            dispatch(boPhanGetAllAction());
        }
    }, [dispatch, list]);

    useEffect(() => {
        if (!Array.isArray(list) || Number.isNaN(id)) return;

        const current = list.find((x) => x.id === id);
        if (current) {
            setMaBoPhan(current.maBoPhan || '');
            setTenBoPhan(current.tenBoPhan || '');
        }
    }, [list, id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (Number.isNaN(id)) {
            toast.error('Thiếu id bộ phận');
            return;
        }

        const model = { maBoPhan, tenBoPhan };

        try {
            setIsSubmitting(true);
            await dispatch(
                boPhanUpdateAction({ id, data: model })
            ).unwrap();

            toast.success(messageToast.messageToastUpdateSuccess);
            history.push(URI_INTERNAL.BOPHAN_PATH);
        } catch (err) {
            console.error('Cập nhật bộ phận lỗi:', err);

            let msg =
                (err && err.message) ||
                (typeof err === 'string' ? err : '') ||
                (err && err.title) ||
                '';

            if (!msg && err && err.errors) {
                msg = Object.values(err.errors).flat().join('; ');
            }

            toast.error(
                msg
                    ? `${messageToast.messageToastUpdateError}: ${msg}`
                    : messageToast.messageToastUpdateError
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    if (Number.isNaN(id)) {
        return (
            <Card>
                <Card.Header as="h5">Sửa bộ phận</Card.Header>
                <Card.Body>Thiếu id</Card.Body>
            </Card>
        );
    }

    return (
        <Card>
            <Card.Header as="h5">Sửa bộ phận</Card.Header>
            <Card.Body>
                <Form noValidate onSubmit={handleSubmit}>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label className="col-sm-2 col-form-label">
                            Mã bộ phận
                        </Form.Label>
                        <Col sm="10">
                            <Form.Control
                                placeholder="Mã bộ phận"
                                type="text"
                                value={maBoPhan}
                                onChange={(e) => setMaBoPhan(e.target.value)}
                                required
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Form.Label className="col-sm-2 col-form-label">
                            Tên bộ phận
                        </Form.Label>
                        <Col sm="10">
                            <Form.Control
                                placeholder="Tên bộ phận"
                                type="text"
                                value={tenBoPhan}
                                onChange={(e) => setTenBoPhan(e.target.value)}
                                required
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Col md={{ span: 10, offset: 2 }}>
                            <ButtonGroup>
                                <Button
                                    type="submit"
                                    theme="primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Đang lưu...' : 'Lưu'}
                                </Button>
                                &nbsp;&nbsp;&nbsp;
                                <Button
                                    type="button"
                                    theme="secondary"
                                    onClick={() =>
                                        history.push(URI_INTERNAL.BOPHAN_PATH)
                                    }
                                    disabled={isSubmitting}
                                >
                                    Hủy
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Form.Group>
                </Form>

                <ReactSpinner loadings={isSubmitting} />
            </Card.Body>
        </Card>
    );
};

export default BoPhanEdit;
